import React from 'react';
import { PortfolioInfo } from 'communication/types/ContactSupportRequest';
import JsonPanel from 'utils/components/JsonPanel/JsonPanel';
import DetailPanel from 'widgets/supportVisualisation/Content/DetailPanel';
import { Tab } from '@instinet-analytics/semantic-ui-components';
import { WidgetPanelGrid } from 'widgets/supportVisualisation/Content/Widgets/WidgetPanelGrid';
import Order from 'communication/types/order/Order';
import {
    PortfolioPosition,
    PortfolioSymbolQuantity,
} from 'portfolio/PortfolioSelection';
import { selectPortfolioStreamingOrderIds } from 'portfolio/store/selectors';
import State from 'store/State';

export function SelectionPanel(props: {
    portfolio: PortfolioInfo;
    width: number;
    height: number;
    state: State;
}) {
    const { height, width, portfolio, state } = props;

    const renderJson = () => <JsonPanel data={portfolio} />;
    const jsonPane = {
        menuItem: 'Json',
        render: renderJson,
    };

    const renderOrders = () => (
        <WidgetPanelGrid<Order>
            key="ordersGrid"
            data={portfolio?.selection?.selectedOrders ?? []}
            getRowDataId={(d) => d.idx.toString()}
            csvFileName={`selected-orders`}
        />
    );
    const ordersPane = {
        menuItem: 'Selected Orders',
        render: renderOrders,
    };

    const renderP = () => (
        <WidgetPanelGrid<PortfolioPosition>
            key="selectedPositionsGrid"
            data={portfolio?.selection?.selectedPositions ?? []}
            getRowDataId={(d) => `${d.symbol}-${d.side}`}
            csvFileName={`selected-positions`}
        />
    );
    const positionsPane = {
        menuItem: 'Selected Positions',
        render: renderP,
    };

    const rendersq = () => (
        <WidgetPanelGrid<PortfolioSymbolQuantity>
            key="selectedSymbolQuantitiesGrid"
            data={portfolio?.selection?.selectedSymbolQuantities ?? []}
            getRowDataId={(d) => `${d.symbol}`}
            csvFileName={`selected-symbol-quantities`}
        />
    );
    const sqPane = {
        menuItem: 'Selected Symbol Quantities',
        render: rendersq,
    };

    const renders = () => (
        <WidgetPanelGrid<string>
            key="selectedSymbolsFrid"
            data={portfolio?.selection?.selectedSymbols ?? []}
            getRowDataId={(d) => d}
            csvFileName={`selected-symbols`}
        />
    );
    const sPane = {
        menuItem: 'Selected Symbols',
        render: renders,
    };

    const streamingOrderIds = selectPortfolioStreamingOrderIds(state);
    const renderStreamingOrderIds = () => (
        <WidgetPanelGrid<{ orderId: string }>
            key="streamingOrderIds"
            data={
                streamingOrderIds.map((i) => ({
                    orderId: i,
                })) ?? []
            }
            getRowDataId={(d) => d.orderId}
            csvFileName={`streaming-order-ids`}
        />
    );
    const sIdsPane = {
        menuItem: 'Streaming Order Ids',
        render: renderStreamingOrderIds,
    };
    const panes = [
        jsonPane,
        ordersPane,
        positionsPane,
        sqPane,
        sPane,
        sIdsPane,
    ];

    return (
        <DetailPanel className="SelectionPanel" height={height} width={width}>
            <Tab
                className="widget-panel-tab"
                panes={panes}
                menu={{ secondary: true, pointing: true, inverted: true }}
            />
        </DetailPanel>
    );
}
